module.exports = __webpack_public_path__ + "img/heading1.ffee236c.png";